import { QuerySkeleton } from "@dash/skeleton";
import { useTheme } from "@emotion/react";
import { MdWarningAmber } from "react-icons/md";

import { useClientManager } from "@megaron/react-clients";

import { SameGooglePlaceTile } from "./SameGooglePlaceTile";

export const SameGooglePlaceAlert: React.FC<{
  googlePlaceId: string;
  customerUuid: string;
  height?: string;
  className?: string;
}> = ({ googlePlaceId, customerUuid, height, className }) => {
  const theme = useTheme();

  const customerWithGooglePlaceIdExistsQuery = useClientManager("docs")
    .customerWithGooglePlaceIdExistsQuery()
    .useQuery({
      googlePlaceId,
    });

  return (
    <QuerySkeleton query={customerWithGooglePlaceIdExistsQuery} height={height ?? "68px"}>
      {(customers) => {
        const filteredThreads = customers.filter((c) => c.uuid !== customerUuid);

        if (filteredThreads.length > 0) {
          return (
            <div css={{ display: "flex", flexDirection: "column", gap: "10px" }} className={className}>
              <span
                css={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: theme.colors.warning,
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <MdWarningAmber size={"20px"} />
                Istnieje klient z taką placówką
              </span>
              <div css={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {filteredThreads.map((customer) => (
                  <SameGooglePlaceTile
                    key={"similar-customer-" + customer.uuid}
                    uuid={customer.uuid}
                    name={customer.name}
                  />
                ))}
              </div>
            </div>
          );
        }
        return null;
      }}
    </QuerySkeleton>
  );
};
